import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { oneKlicks } from '../../../../SDK/oneclick';
import ImageShow from '../../../../Uitiles/ImageShow';

const SliderSection = ({ os }) => {
  console.log("os SliderSection :", os);
  const [slides, setSlides] = useState([]); // Empty state for slides
  const carouselRef = useRef(null);
  const [currentId, setCurrentId] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const autoSlideInterval = useRef(null);
  const [mobileSliderData, setMobileSliderData] = useState([]);
  const touchStartX = useRef(0);


  // Static placeholder slides (replace with API later)
  const placeholderSlides = [
    {
      id: 1,
      imgSrc: "//css.meddylist.com//wp-content/uploads/2019/08/img-01-1.png",
      title: "Emergency?",
      title1: "Find Nearest",
      title2: "Medical Facility",
      num: "01.",
      btnText1: "View Hospitals",
      btnText2: "View Doctors",
      btnLink: "/search-hospitals",
      btnLink2: "/search-doctors"
    },
    {
      id: 2,
      imgSrc: "//css.meddylist.com//wp-content/uploads/2019/08/img-02-3.png",
      title: "Emergency?",
      title1: "Find Nearest",
      title2: "Medical Facility",
      num: "02.",
      btnText1: "View Hospitals",
      btnText2: "View Doctors",
      btnLink: "/search-hospitals",
      btnLink2: "/search-doctors"
    },
    {
      id: 3,
      imgSrc: "//css.meddylist.com//wp-content/uploads/2019/08/img-03-2.png",
      title: "Emergency?",
      title1: "Find Nearest",
      title2: "Medical Facility",
      num: "03.",
      btnText1: "View Hospitals",
      btnText2: "View Doctors",
      btnLink: "/search-hospitals",
      btnLink2: "/search-doctors"
    }
  ];

  // Placeholder function to simulate API data fetching
  useEffect(() => {
    // Simulate fetching data from an API (using placeholderSlides here)
    setSlides(placeholderSlides);
    getMobileSliderData();
  }, []);

  const getMobileSliderData = async () => {
    try {
      const tableSchema = "";
      const tableName = "banners";
      const conditions = {
        status: "active",
        banner_type: "hero"
      };
      const orderBy = "id ASC";
      const search = "";
      const pagination = "";
      const margedata = "";
      const data = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

      console.log("getMobileSliderData response :", data);
      if (data.success) {
        if (data.data.length > 0) {
          setMobileSliderData(data.data);
          setCurrentId(0); // Reset to first slide when data loads
        } else {
          setMobileSliderData([]);
        }
      } else {
        console.log("error", data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  // Auto-slide functionality - works for both mobile and desktop
  useEffect(() => {
    const isMobile = os === "android" || os === "ios";
    const dataLength = isMobile ? mobileSliderData.length : slides.length;

    if (dataLength > 0) {
      autoSlideInterval.current = setInterval(() => {
        setCurrentId((prevId) => (prevId + 1) % dataLength);
      }, 5000); // Change slide every 5 seconds

      return () => {
        if (autoSlideInterval.current) {
          clearInterval(autoSlideInterval.current);
        }
      };
    }
  }, [os, slides.length, mobileSliderData.length]);

  const handleNext = () => {
    if (isTransitioning) return;

    const isMobile = os === "android" || os === "ios";
    const dataLength = isMobile ? mobileSliderData.length : slides.length;

    if (dataLength === 0) return;

    setIsTransitioning(true);
    setCurrentId((prevId) => (prevId + 1) % dataLength);

    // Reset transition state after animation completes
    setTimeout(() => {
      setIsTransitioning(false);
    }, 600);
  };

  const handlePrev = () => {
    if (isTransitioning) return;

    const isMobile = os === "android" || os === "ios";
    const dataLength = isMobile ? mobileSliderData.length : slides.length;

    if (dataLength === 0) return;

    setIsTransitioning(true);
    setCurrentId((prevId) => (prevId - 1 + dataLength) % dataLength);

    // Reset transition state after animation completes
    setTimeout(() => {
      setIsTransitioning(false);
    }, 600);
  };

  const goToSlide = (index) => {
    if (isTransitioning || index === currentId) return;

    setIsTransitioning(true);
    setCurrentId(index);

    setTimeout(() => {
      setIsTransitioning(false);
    }, 600);
  };

  return (
    <>
      {os === "android" || os === "ios" ? (
        <>
          {mobileSliderData.length > 0 ? (
            <div className="mobile-slider-container">
              <div
                className="mobile-slider-content"
                style={{
                  transform: `translateX(-${currentId * 100}%)`,
                  transition: isTransitioning ? "transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)" : "none",
                }}
                onTouchStart={(e) => {
                  touchStartX.current = e.touches[0].clientX;
                }}
                onTouchEnd={(e) => {
                  const touchEndX = e.changedTouches[0].clientX;
                  const diff = touchStartX.current - touchEndX;

                  if (Math.abs(diff) > 50) {
                    if (diff > 0) {
                      handleNext();
                    } else {
                      handlePrev();
                    }
                  }
                }}
              >
                {mobileSliderData.map((slide, index) => (
                  <div key={index} className={`mobile-slider-item ${currentId === index ? 'active' : ''}`}>
                    <ImageShow url={slide.imageUrl} height={0} width={0} />
                    {(slide.title || slide.sub_title) && (
                      <div className="mobile-slider-overlay">
                        {slide.title && <h3>{slide.title}</h3>}
                        {slide.sub_title && <p>{slide.sub_title}</p>}
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* --- Bullets --- */}
              {mobileSliderData.length > 1 && (
                <div className="mobile-slider-indicators">
                  {mobileSliderData.map((_, index) => (
                    <span
                      key={index}
                      className={`mobile-indicator ${currentId === index ? "active" : ""}`}
                      onClick={() => goToSlide(index)}
                      aria-label={`Go to slide ${index + 1}`}
                    />
                  ))}
                </div>
              )}
            </div>
          ) : (
            <div className="mobile-slider-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}>
              <p style={{ color: '#999', fontSize: '16px' }}></p>
            </div>
          )}
        </>
      ) : (
        <>
          <section className="elementor-section elementor-top-section elementor-element elementor-element-bd1b47c elementor-section-stretched elementor-section-full_width elementor-section-height-default elementor-section-height-default">
            <div className="elementor-container elementor-column-gap-no">
              <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-680df21">
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div className="elementor-element elementor-element-0c7eb5b elementor-widget elementor-widget-dc_element_slider_v1">
                    <div className="elementor-widget-container">
                      <div className="dc-sc-slider dc-homesliderholder dc-haslayout dynamic-secton">
                        <div id="dc-homeslider" className="dc-homeslider" ref={carouselRef}>
                          <div id="carouselControls" className="carousel slide" data-ride="FALSE">
                            <div className="carousel-inner">
                              {slides.map((slide, index) => (
                                <div
                                  className={`carousel-item ${currentId === index ? 'active' : ''}`}
                                  id={slide.id}
                                  key={slide.id}
                                  style={{
                                    transform: `translateX(${(index - currentId) * 100}%)`,
                                    transition: isTransitioning ? 'transform 0.5s ease-in-out' : 'none'
                                  }}
                                >
                                  <div className="d-flex justify-content-center dc-craousel-content">
                                    <div className="mx-auto">
                                      <img
                                        decoding="async"
                                        className="d-block dc-bannerimg slider-image"
                                        src={slide.imgSrc}
                                        alt="Emergency?"
                                      />
                                      <div className="dc-bannercontent dc-bannercotent-craousel">
                                        <div className="dc-content-carousel">
                                          <div className="dc-num">{slide.num}</div>
                                          <h1>
                                            <em>{slide.title}</em> {slide.title1} <span>{slide.title2}</span>
                                          </h1>
                                          <div className="dc-btnarea dc-btnarea-craousel">
                                            <Link to={slide.btnLink} className="dc-btn dc-btnactive dc-btn-craousel-1">
                                              {slide.btnText1}
                                            </Link>
                                            <Link to={slide.btnLink2} className="dc-btn dc-btn-craousel-2">
                                              {slide.btnText2}
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                            <a
                              className="dc-carousel-control-prev"
                              role="button"
                              data-slide="prev"
                              onClick={handlePrev}
                            >
                              <span className="dc-carousel-control-prev-icon" aria-hidden="true">
                                <span>PR</span>
                                <span className="d-block">EV</span>
                              </span>
                              <span className="sr-only">Previous</span>
                            </a>
                            <a
                              className="dc-carousel-control-next"
                              role="button"
                              data-slide="next"
                              onClick={handleNext}
                            >
                              <span className="dc-carousel-control-next-icon" aria-hidden="true">
                                <span>NE</span>
                                <span className="d-block">XT</span>
                              </span>
                              <span className="sr-only">Next</span>
                            </a>

                            {/* Slide Indicators */}
                            <div className="carousel-indicators">
                              {slides.map((_, index) => (
                                <button
                                  key={index}
                                  type="button"
                                  className={`indicator ${currentId === index ? 'active' : ''}`}
                                  onClick={() => goToSlide(index)}
                                  aria-label={`Go to slide ${index + 1}`}
                                />
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default SliderSection;
